const $ = require('jquery');
const isFunction = require('lodash/isFunction');
const isArray = require('lodash/isArray');
const flatten = require('lodash/flatten');
const log = require('debug')('linksoft:initialize');

// An array of all registered initializers.
const _initializers = [];
// finalizers performs clean up before an element is removed from DOM
const _finalizers = [];

/**
 * Triggers initialize event for given element.
 * @param {jQuery} selector - jQuery element selector. When missing document is used as target.
 * @param args
 * @returns {void}
 */
function initialize (selector, ...args){
    const target = selector || document;
    const $e = $(target);
    log('triggering %i initializers on %o', _initializers.length, target);
    _initializers.forEach(i => {
        i.apply($e, args);
    });
}

function finalize (selector, ...args) {
    let target = selector || document;
    let $e = $(target);
    log('triggering %i finalizers on %o', _finalizers.length, target);
    _finalizers.forEach(i => {
        i.apply($e, args);
    });
}

/**
 * Registers a function as initializer function to be called when initialize event occurs.
 * @param {function} initializer
 * @param isFinalizer If true, function is registered as finalizer
 * @returns {void}
 */
function register(initializer, isFinalizer = false) {
    const store = isFinalizer ? _finalizers : _initializers;
    if(isArray(initializer)) {
        flatten(initializer).forEach(i => {
            store.push(i);
        });
    }
    else if (isFunction(initializer)) {
        store.push(initializer);
    }
}

export default {
    register,
    initialize,
    trigger: initialize,
    finalize
};


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initialize.js